import AccessDenied from './AccessDenied.page';
export default AccessDenied;
